import React from "react"
import styles from "./arc.module.scss"

// import Intro from "./intro"
import Roles from "./roles"
import Plot from "./plot"
import Worlds from "./worlds"
import Collect from "./collect"

const Arc = () => {
  return (
    <div id="block-arc" className={styles.container}>
      {/* <Intro /> */}
      <Roles />
      <Plot />
      {/* <Worlds /> */}
      {/* <Collect /> */}
    </div>
  )
}

export default Arc
